import React, { useState } from 'react';
import * as actionCreators from '../actions';
import { FileUploader } from "react-drag-drop-files";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Fade } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import Inputs from '../Components/Inputs';
import axios from 'axios';
import '../pages/styles.css';


const fileTypes = ["png"];

function Settings({ infoCompany }) {
    const [files, setFiles] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (files) => {
        if (files.name.endsWith("png")) {
            setFiles(files);
            setError(false)
        } else {
            setError(true);
        }
    };

    const uploadFiles = async () => {
        if (files !== null) {
            setLoading(true);
            const url = `${process.env.REACT_APP_NODE_APP}/uploadBackground/${infoCompany.abremp}`;
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const formData = new FormData();
            formData.append("background", files);
            await axios.post(url, formData, options)
                .then(r => {
                    setLoading(false);
                    setFiles(null);
                })
                .catch(() => {
                    setLoading(false);
                })
        }
        else return;
    };

    return (
        <>
            <Fade appear in>
                <div className="abm">
                    <div className="qs container max-shadow">
                        <h1>Configuración</h1>
                        <h3>Subir Fondo</h3>
                        <br />
                        <div className="row">
                            <div className="col-sm-6 col-lg-6">
                                <FileUploader
                                    multiple={false}
                                    handleChange={handleChange}
                                    types={fileTypes}
                                    name="terminos"
                                />
                            </div>
                            <Inputs
                                type={"button"}
                                title={<FontAwesomeIcon icon={faCloudArrowUp} />}
                                onClick={!error && !loading && files && uploadFiles}
                                disabled={error || loading || !files}
                                className="col-sm-2 col-md-1 col-lg-1 offset-sm-3 offset-md-1 offset-lg-0 "
                            />
                        </div>
                        <p>Una vez subido el archivo, recargue la página para ver el cambio</p>
                        {files && <p>Archivo a subir: <b>{files.name}</b></p>}
                    </div>
                </div>
            </Fade>
        </>
    )
}

function mapStateToProps(state) {
    return {
        infoCompany: state.mainReducer.infoCompany,
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
